import { render, staticRenderFns } from "./FeaturedListItem.vue?vue&type=template&id=18f75c42&scoped=true&lang=pug&"
import script from "./FeaturedListItem.vue?vue&type=script&lang=js&"
export * from "./FeaturedListItem.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedListItem.vue?vue&type=style&index=0&id=18f75c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f75c42",
  null
  
)

export default component.exports